import {GenericDescription, List, ListItem, MarkdownImage, Quote, TableFigure} from './plugins/bb-codes';

import css from './markdown.module.css';

export const replacesTags: Record<string, {tag: React.ElementType; props?: Record<string, string>}> = {
	blockPlugin: {
		tag: 'div',
	},
	center: {
		tag: 'div',
		props: {
			className: css.center,
		},
	},
	// блоки в ряд с переносом: `[flex]таблица таблица[/flex]` — две таблицы бок о бок, на узком экране одна под другой
	flex: {
		tag: 'div',
		props: {
			className: css.flex,
		},
	},
	blockquote: {
		tag: 'blockquote',
		props: {
			className: css.blockquote,
		},
	},
	blockquoteAuthor: {
		tag: 'div',
		props: {
			className: css.blockquoteAuthor,
		},
	},
	// врезка — дополняющий материал рядом с основным текстом
	inset: {
		tag: 'aside',
		props: {
			className: css.sidebar,
		},
	},
	// кусок блока параметров: атака или черта чудовища, набранная прямо в тексте раздела
	statblockPiece: {
		tag: 'div',
		props: {
			className: css.statblockPiece,
		},
	},
	indent: {
		tag: 'div',
		props: {
			className: css.indent,
		},
	},
	list: {
		tag: List,
	},
	item: {
		tag: ListItem,
	},
	ul: {
		tag: 'ul',
		props: {
			className: css.ul,
		},
	},
	ol: {
		tag: 'ol',
		props: {
			className: css.ol,
		},
	},
	quote: {
		tag: Quote,
	},
	read: {
		tag: 'blockquote',
		props: {
			className: css.readaloud,
		},
	},
	tableFigure: {
		tag: TableFigure,
	},
	bookImage: {
		tag: MarkdownImage,
	},
	imageRow: {
		tag: 'div',
		props: {
			className: css.imageRow,
		},
	},
	inlineHeading: {
		tag: 'strong',
		props: {
			className: css.inlineHeading,
		},
	},
	genericDescription: {
		tag: GenericDescription,
	},
};
